import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {IBigWinLevel} from "../server/IDjPsychoData";
import {DjPsychoSound} from "../sound/DjPsychoSound";


export class DjPsychoBigWinRunner implements ISimplePresentation {
    private _bigWinSound: string = "";

    public shouldRun(): boolean {
        return DjPsycho.model.gameData.totalSpinRoundWinnings > 0 && (DjPsycho.model.endOfAvalanche(DjPsycho.model.data.mode, DjPsycho.model.data.nextMode) && DjPsycho.model.winRatio >= 15);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const levels: IBigWinLevel[] = DjPsycho.model.getBigWinLevels(DjPsycho.model.winRatio),
            tl: TimelineLite = new TimelineLite({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            });
        let levelAborted: boolean;

        for (let index: number = 0; index < levels.length; index++) {
            const bigWinLevel: IBigWinLevel = levels[index],
                from: number = bigWinLevel.from * DjPsycho.model.gameData.playedBetValue,
                to: number = bigWinLevel.to * DjPsycho.model.gameData.playedBetValue;

            tl.add(() => {
                levelAborted = false;
                if (index === 0) {
                    DjPsycho.soundPlayer.fadeMusic({
                        name: "",
                        duration: 100,
                        to: 0
                    });
                }
                this._bigWinSound = DjPsychoSound.BIG_WIN_NAME + (index + 1);
                DjPsycho.soundPlayer.playSound(this._bigWinSound);

                controller.setSkipCallback(() => {
                    levelAborted = true;
                    tl.seek(bigWinLevel.type + "_end", false);
                });
            });
            tl.add(DjPsycho.totalBigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id));
            tl.addLabel(bigWinLevel.type + "_end");
            tl.add(() => {
                if (levelAborted && this._bigWinSound) {
                    DjPsycho.soundPlayer.stopSound(this._bigWinSound);
                }
            })
        }
        tl.add(() => {
            this._bigWinSound = "";

            // #152
            if (!DjPsycho.model.gameData.brokeBank) {
                DjPsycho.soundPlayer.fadeMusic({
                    name: "",
                    duration: 1000,
                    to: 1
                });
            }
            
            DjPsycho.soundPlayer.playSound(DjPsychoSound.BIG_WIN_ENDS);

            controller.setSkipCallback();
            DjPsycho.keypadPlugin.setWin(DjPsycho.model.gameData.accumulatedRoundWin, true, DjPsycho.isWinBelowStake());
        });
        tl.to(this, {
            duration: 0.5
        });
        tl.add(DjPsycho.totalBigWinView.hide(0.5));
    }
}